import React, {Component} from 'react';
import {connect} from 'react-redux';
import RadioGroup from '../base/radiogroup';
import api from '../../utils/api';
import DatePicker from 'material-ui-pickers/DatePicker';
import moment from "moment";
import axios from "axios/index";
import {tokenHeader} from "../../utils/headers";
import urls from "../../utils/urls";
import {ajaxHandler} from "../../utils/errors";
import {dateTimeFormat} from "../../utils/formatters";
import LoadingSpinner from "../../components/spinner/Spinner";
import {toast} from "react-toastify";

class CrearNuevo extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loader: ' loader-box',
            title: 'Paso 2',
            selectedClusters: [],
            allActive: false,
            products: {},
            clusters: [],
            fileStatus: "",
            dueDate: moment(),
            file: false,
            download:false,
            all: {id: 0, label: '', active: false},
            simulador: this.props.simulador
        };

        this.getCluster = this.getCluster.bind(this);
        this.getAll = this.getAll.bind(this);
        this.addSimuladorData = this.addSimuladorData.bind(this);
    }


    componentDidMount() {
        let _self = this;
        let products = {};

        api.get('clusters/difference').then(resp => {
            resp.data.forEach((cluster, key) => {
                resp.data[key].products = {};
                cluster.differentials.forEach(strategy => {
                    products[strategy.product_name] = true;
                    resp.data[key].products[strategy.product_name] = parseFloat(strategy.actual_difference).toFixed(2);
                });
            });
            _self.setState({clusters: resp.data, products: products, loader: ''})
        });

    }

    _downloadTemplate = () => {
        if(this.state.download) return false;
        this.setState({download: true});
        toast.success('En segundos comenzará su descarga');
        api.get('import/reference-prices/').then(resp => {
            const fileURL = `${urls.API_ROOT}${resp.data.url}`;
            window.location = fileURL;
            this.setState({download: false});
        }).catch(e => {
            toast.error('No se pudo descargar el archivo. Inténtelo nuevamente');
            this.setState({download: false});
        });
    };

    getAll(item) {
        let _self = this;
        let selectAll = !_self.state.allActive;
        let all = item;
        all.active = !all.active;

        let clusters = JSON.parse(JSON.stringify(this.state.clusters));
        clusters.forEach((cluster, i) => {
            clusters[i].active = selectAll;
        });
        this.setState({
            allActive: selectAll,
            clusters: clusters,
            all: all
        });
    }

    getCluster(item, removedItem) {
        let clusters = JSON.parse(JSON.stringify(this.state.clusters));

        this.setState({
            clusters: clusters
        }, function () {
            this.refs['radio_' + removedItem.id].update();
        });
    }

    _checkState = (reportId) => {
        const simulation_url = `${urls.API_ROOT}/api/v1/simulations/id/${reportId}/`;
        axios
            .get(simulation_url, tokenHeader())
            .then((response) => {
                let fileStatus = response.data.status;
                if (fileStatus === "IN_PROCESS") {
                    this.setState({fileStatus: "Cargando Archivo"});
                    setTimeout(() => this._checkState(reportId), 2000);
                }
                if (fileStatus === "DRAFT") {
                    this.setState({fileStatus: ''});
                    window.history.pushState('simulador', this.state.simulador.name, '/simulador/nuevo/' + response.data.id);
                    this.props.setEditId(response.data.id);
                    this.props.switchToStep(5, response.data);
                }

            })
            .catch((error) => console.log(error));
    };


    addSimuladorData() {
        if (this.props.simulador.type === "MASIVE" && (!this.state.file || !this.state.dueDate)) {
            window.Materialize.toast("La fecha y el archivo son obligatorios", 3000);
            return false;
        }


        let headers = tokenHeader();
        headers['headers']['content-type'] = "multipart/form-data";

        let formData = new FormData();
        formData.append("name", this.props.simulador.name);
        formData.append("period", dateTimeFormat(this.state.dueDate));
        formData.append("file", this.state.file);

        if (this.state.file) {
            this.setState({fileStatus: "Validando Archivo"})
            const upload_file_url = `${urls.API_ROOT}/api/v1/import/reference-prices/`;
            axios
                .post(upload_file_url, formData, headers)
                .then((response) => {
                    this._checkState(response.data.id);
                })
                .catch(error => {
                    let ajaxErrors = ajaxHandler(error);
                    if(ajaxErrors instanceof Array){
                        let error_list = ajaxErrors.find(error => error.key === 'error_lists');
                        if(error_list){
                            let errors = error_list.text.map(each => {
                                return `Fila ${each.row + 1}: ${each.error}`
                            });
                            this.setState({errors, fileStatus: ''});
                        }
                    }
                });

        } else {
            let simuladorData = JSON.parse(JSON.stringify(this.state.simulador));
            let clusters = [];
            this.state.clusters.forEach(c => {
                if (c.active) {
                    clusters.push(c.id)
                }
            });

            let save = {
                name: simuladorData.name,
                simulation_type: simuladorData.type,
                pricing_clusters_list: clusters
            };

            let step = 3;
            if (simuladorData.type === "REACTIVE") {
                step = 4;
            }

            api.post("simulations/", save).then(out => {
                if (out.status === 201) {
                    window.history.pushState('simulador', this.state.simulador.name, '/simulador/nuevo/' + out.data.id);
                    this.props.setEditId(out.data.id);
                    this.props.switchToStep(step, out.data);
                }
            })
        }

    }

    _handleDateChange = (date) => {
        this.setState({dueDate: date});
    };

    handleFileChange(file) {
        this.setState({file});
    }

    render() {
        let _self = this;
        let today = new Date();


        let body = <div className="col s6">
            <div className="grid-header">
                <div className="row">
                    <div className="col s6">
                        <h4>Seleccion ({_self.state.clusters.filter(cluster => {
                            return cluster.active
                        }).length})</h4>
                    </div>
                    <div className="col s6">
                        <span className="grid-title">Diferencia Actual (%)</span>
                        <div className="row">
                            <div className="col s12">
                                <div className="row">
                                    {Object.keys(_self.state.products).map(key => {
                                        return <div key={key} className="col s3">
                                            <span>{key}</span>
                                        </div>
                                    })}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col s12">
                    <div className="simulador_new-draft_selection_clusters">
                        <div>
                            <div className="simulador_new-draft_selection_clusters_cluster">
                                <div className="row">
                                    <RadioGroup allowNull={true} ref="all" text='' items={[_self.state.all]}
                                                getItem={_self.getAll}/>
                                    <div className="col s6">
                                        <span className="cluster-title">TODOS LOS CLUSTERS</span>
                                    </div>
                                    <div className="col s6">
                                        &nbsp;
                                    </div>
                                </div>
                            </div>
                        </div>
                        {this.state.clusters.map((cluster, i) => {
                            return <div key={i}>
                                <div className="simulador_new-draft_selection_clusters_cluster">
                                    <div className="row">
                                        <RadioGroup allowNull={true} ref={"radio_" + _self.state.clusters[i].id} text=''
                                                    items={[_self.state.clusters[i]]} getItem={_self.getCluster}/>

                                        <div className="col s6">
                                            <span className="cluster-title">{_self.state.clusters[i].name}</span>
                                        </div>
                                        <div className="col s6">
                                            <div className="row">
                                                {Object.keys(_self.state.clusters[i].products).map(key => {
                                                    return <div key={key} className="col s3">
                                                        <span
                                                            className="cluster-price">{_self.state.clusters[i].products[key]}</span>
                                                    </div>
                                                })}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        })}
                    </div>
                </div>
            </div>
        </div>;

        if (_self.props.simulador.type === 'MASIVE') {
            body = <div className="col s6">
                <div className="row">
                    <div className={"label"}>Fecha de Vigencia</div>
                    <DatePicker
                        minDate={new Date().setMonth(today.getMonth() - 5)}
                        maxDate={new Date().setDate(today.getDate() + 5)}
                        value={this.state.dueDate}
                        format={'DD/MM/YYYY'}
                        cancelLabel={'Cancelar'}
                        onChange={this._handleDateChange}
                        className={'date-input-field'}
                        minDateMessage={'La fecha debe ser una fecha futura'}
                    />
                </div>
                <input type="file" onChange={(e) => this.handleFileChange(e.target.files[0])} name="file" id="file"
                       className="inputfile"/>
                <label htmlFor="file">Subir Archivo</label>
                {this.state.file &&
                <div style={{display: 'inline-block', marginLeft: 10}}>{this.state.file.name}</div>
                }

                <div className={"download"}>
                    <div className={"text"} onClick={this._downloadTemplate}>Descargar Template</div>
                </div>

                {this.state.errors &&
                <div className={"errors"}>
                    <div className={"title"}>ERRORES</div>
                    <div className={"div-list"}>
                        <ul>
                            {this.state.errors.map((error, i) => {
                                return <li key={i}>{error}</li>
                            })}
                        </ul>
                    </div>
                </div>}

                {this.state.fileStatus !== '' &&
                <div className={"errors"}>
                    <div className={"status"}>{this.state.fileStatus}</div>
                    <LoadingSpinner width={50}/>
                </div>}
            </div>
        }

        return (
            <div>
                <section className="simulador">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col s12">
                                <div className="simulador_box">
                                    <div className="simulador_box_title">
                                        <h2>Crear Nuevo</h2>
                                    </div>
                                    <div className={"simulador_box_content-alt" + this.state.loader}>
                                        <div className="simulador_new-draft_selection">
                                            <div className="row">
                                                <div className="col s3">
                                                    <h2>{_self.props.simulador ? _self.props.simulador.name : ''}</h2>
                                                    <h3>{_self.props.simulador ? (_self.props.simulador.type === 'REACTIVE' ? 'Cambio Reactivo' : (_self.props.simulador.type === 'PROACTIVE' ? 'Cambio Proactivo' : 'Carga Masiva')) : ''}</h3>
                                                </div>
                                                {body}
                                            </div>
                                        </div>
                                        <div className="simulador_new-draft_next">
                                            <div className="row">
                                                <div className="col s3">
                                                    <div className="cta-container">
                                                        <button className="cta-light" onClick={() => {
                                                            _self.props.switchToStep(1)
                                                        }}>
                                                            <img className="light" alt=""
                                                                 src="/static/imgs/arrow-light.svg"/>
                                                            <img className="dark" alt=""
                                                                 src="/static/imgs/angle-right.svg"/>
                                                            <span>Atrás</span>
                                                        </button>
                                                    </div>
                                                </div>
                                                <div className="col s6">
                                                    <div className="btn-container">
                                                        <button className="cta" href="#"
                                                                onClick={this.addSimuladorData}>
                                                            <span>Crear</span>
                                                        </button>
                                                    </div>
                                                </div>
                                                <div className="col s3">

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        );
    }

}

const mapStateToProps = (state) => {
    return {
        user: state.user
    }
}

export default connect(mapStateToProps)(CrearNuevo);



// WEBPACK FOOTER //
// ./src/containers/simulador/crearNuevo.js